import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./auth/App";
import CustomLoginPage from "features/LoginPage";
import { settings } from "./app/settings";
import LoginPagePassword from "features/LoginPagePassword";

const tenant = settings.tenant;

const titles = {
  mu: "МУ - Административен панел",
  mgu: "МГУ - Административен панел",
  su: "СУ - Административен панел",
};
document.title = titles[tenant];

const favicons = {
  mu: "/favicon-mu.ico",
  mgu: "/favicon-mgu.ico",
  su: "/favicon-su.ico",
};
const faviconPath = favicons[tenant];
let link = document.querySelector("link[rel~='icon']");
link.href = faviconPath;

const loginPageMap = { su: LoginPagePassword };
const ActiveLoginPage = loginPageMap[settings.tenant] ?? CustomLoginPage;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App
    title={titles[tenant] || "Административен панел"}
    loginPage={ActiveLoginPage}
    //authProvider={authProvider}
    //  authProvider={settings.noAuth !== true ? authProvider : null}
    //dataProvider={dataProvider}
  />,
);
